import { ChartRenderData } from "@/modules/Dashboards/AdminDashboard/models/ChartRenderData";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const ACTIONS = {
  ADD_FILE: "Crear archivo multimedia",
  CANCEL: "Cancelar"
};

export const MULTIMEDIA_FILTERS = {
  MAIN: {
    mainFilterKey: "name",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: [] as SecondaryFilter[],
    initial: true,
    placeholder:
      "Escriba el nombre del usuario o utiliza los filtros para agrupar información"
  },
  SECONDARY: {
    NAME: {
      name: "Nombre",
      placeholder: "Nombre de Multimedia",
      key: "name",
      avatar: "mdi-form-textbox",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "unique"
    },
    TYPE: {
      name: "Tipo",
      placeholder: "Tipo de Multimedia",
      key: "type",
      avatar: "mdi-checkbox-multiple-blank",
      type: "secondaryFilter",
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: [
        { key: "imagen", name: "Imagen" },
        { key: "documento", name: "Documento" },
        { key: "video", name: "Video" },
        { key: "audio", name: "Audio" },
        { key: "url", name: "Url" }
      ]
    },
    CATEGORY: {
      name: "Categoria",
      placeholder: "Categoria de Multimedia",
      key: "category",
      avatar: "mdi-shape-plus",
      type: "secondaryFilter",
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: []
    },
    STATE: {
      name: "Estado",
      placeholder: "Estado de Multimedia",
      key: "state",
      avatar: "mdi-list-status",
      type: "secondaryFilter",
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: [
        { name: "Activo", key: "true" },
        { name: "Inactivo", key: "false" }
      ]
    }
  }
};

export const FILE_NAME = "Nombre del archivo";

export const NEW_FILE = {
  _key: "",
  type: "",
  category: "",
  state: true,
  name: "",
  multimediaPath: "",
  fieldName: "",
  fieldSize: ""
};

export const MULTIMEDIA_CONSTANTS = {
  PAGE_TITLE_SEARCH: "Consulta multimedia",
  STATE: "state",
  PAGE_TITLE: "Multimedia",
  PAGE_TITLE_EDIT: "Editar archivo",
  ACTIVO: "Activo",
  TYPE_LABEL: "Tipo",
  CATEGORY_LABEL: "Categoria",
  CATEGORY: "category",
  CATEGORY_MULTIMEDIA_ID: "t71RiYbinHkDmkF4w4S9",
  MULTIMEDIA_FOLDER: "multimedia",
  SAVE_SUCCESS: "Archivo guardado de forma exitosa",
  UPDATE_SUCCESS: "Archivo multimedia actualizado de forma exitosa",
  SAVED_FILE: "savedFile",
  CANCEL_ACTION: "create",
  CREATE_ACTION: "cancel",
  INVALID_FILE: "El tipo de archivo no es válido",
  INVALID_FILE_SIZE: "El tamaño del archivo debe ser menor a 10MB",
  SAVE_FILE: "save",
  CANCEL_FILE: "cancel",
  SELECT_FILE: "Seleccione archivo",
  SAVE_FILE_FORM: "saveFileContent",
  SAVE_FILE_CONFIRMATION_TEXT: "¿Esta seguro de guardar este archivo?",
  SAVE_FILE_CONFIRMATION_TITLE: "Guardar",
  FILE_CATEGORY: "Categoría de archivo",
  FILE_TYPE: "Tipo de archivo",
  TYPE: "type",
  FALSE: "false",
  URL: "url",
  MULTIMEDIA_DELETE_SUCCESFULLY: "multimedia eliminado correctamente",
  YOUTUBE_HOST: "www.youtube.com",
  YOUTUBE_PATH_EMBED: "https://www.youtube.com/embed",
  V_PARAM_YOUTUBE: "v",
  INVALID_URL: "Url no válida",
  DOCUMENT: "documento",
  MULTIMEDIA_USED:
    "El archivo multimedia está siendo usado, no se puede eliminar.",
  AUDIO_FILE: "audio"
};

export const TYPE_FILES = [
  {
    key: "imagen",
    name: "Imagen (.PNG, .JPEG, .SVG, .TIFF)",
    formats: ".png, .jpeg, .svg, .tiff"
  },
  {
    key: "documento",
    name: "Documento (.PDF, .txt, .docx, .xlsx)",
    formats: ".pdf, .txt, .docx, .xlsx"
  },
  {
    key: "video",
    name: "Video (.MP4, .WMV, .MOV, .AVI)",
    formats: ".mp4, .wmv, .mov, .avi"
  },
  {
    key: "audio",
    name: "Audio (.MP3, .WAV, .AAC)",
    formats: ".mp3, .wav, .aac"
  },
  {
    key: "url",
    name: "Url (http//...)",
    formats: "http"
  }
];

export const CHART_DATA_RENDER: ChartRenderData = {
  labels: [],
  datasets: [
    {
      data: []
    }
  ]
};

export const MULTIMEDIA_ACCESS = {
  GET: "consultar archivos de multimedia",
  POST: "crear archivos de multimedia",
  PUT: "modificar archivos de multimedia",
  DELETE: "eliminar archivos de multimedia"
};

export const MULTIMEDIA_ICONS_FILE_TYPE = {
  AUDIO: "mdi-ear-hearing",
  IMAGEN: "mdi-eye"
};
